export enum NavigationAuthorization {
  foulingSimulatorNavigate = 'fouling_simulator:navigate',
  vesselProfilerNavigate = 'vessel_profiler:navigate',
  performanceSimulatorNavigate = 'performance_simulator:navigate',
  cargoPredictionNavigate = 'cargo_prediction:navigate',
  vesselModelsNavigate = 'vessel_models:navigate',
  deploymentPlannerNavigate = 'deployment_planner:navigate',
  scheduleRecoveryNavigate = 'schedule_recovery:navigate',
  ciiFleetRatingsNavigate = 'cii:fleet_ratings:navigate',
  ciiFleetPerformanceNavigate = 'cii:fleet_performance:navigate',
  ciiEeoiNavigate = 'cii:eeoi:navigate',
  ciiHomeNavigate = 'cii:home:navigate',
  ciiSimulatorNavigate = 'cii:simulator:navigate',
  chatbotNavigate = 'chatbot:navigate',
}

export enum FleetPerformanceAuthorization {
  speedConsumptionCurve = 'cii:fleet_performance:speed_consumption_curve',
  foulingResistanceTrend = 'cii:fleet_performance:fouling_resistance_trend',
  foulingResistanceColumn = 'cii:fleet_performance:fouling_resistance_column',
}

export enum FleetRatingsAuthorization {
  yearPicker = 'cii:fleet_ratings:year_picker',
}
